import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class IowaLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Iowa" />
        <LocationMicroNav />

        <LocationContent 
          category="Promoting Ridership" 
          title="Over the River and Through the Woods"
          story="RAGBRAI (Register’s Annual Great Bicycle Ride Across Iowa) is one of the oldest, largest and longest recreational bicycle touring events in the world. So it was truly an honor to take the stage during this epic event and spend a day riding across the hills of Iowa. While the route is different each year, one constant is RAGBRAI’s support of PeopleForBikes. Our simple message to the more than 10,000 riders from all 50 states: If you love bike riding, and if you love RAGBRAI, the best thing to do is join PeopleForBikes so you can speak up for bicycling when we call on our members. "
        />  
        <Img
          title="Iowa 1-1"
          alt="RAGBRAI (Register’s Annual Great Bicycle Ride Across Iowa)"
          sizes= { this.props.data.iowaOneOneImage.sizes }
        />    
      
        <LocationRelated 
          prevLocationName="Memphis, TN"
          prevLocationPath="memphis"
          prevLocationImgPath= { this.props.data.iowaPrevImage }
          nextLocationName="Arlington, VA"
          nextLocationPath="arlington"
          nextLocationImgPath= { this.props.data.iowaNextImage }
        /> 
      </div>
    )
  }
}

export default IowaLocation

// GraphQL query
export const IowaImageQuery = graphql`
  query IowaImageQuery {
    iowaOneOneImage: imageSharp(id: { regex: "/PFB_Iowa_1-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    iowaPrevImage: imageSharp(id: { regex: "/PFB_MEMPHIS/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    iowaNextImage: imageSharp(id: { regex: "/PFB_ARLINGTON/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/iowa.js